
import { createVeriffFrame, MESSAGES } from '@veriff/incontext-sdk';
import Button from '@/ui-kit/components/button';
import api from '@/utils/api';
import { VerificationStatus } from '@/enums/user';

/**
 * Veriff component.
 *
 * @public
 */

export default {
  name: 'VeriffComponent',
  components: {
    Button,
  },
  props: {
    user: {
      type: Object,
      default: null,
      firstName: {
        required: true,
        type: String,
      },
      lastName: {
        required: true,
        type: String,
      },
      email: {
        required: true,
        type: String,
      },
      idVerificationStatus: {
        required: true,
        type: String,
      },
    },
  },
  data() {
    return {
      veriff: null,
      loading: false,
    };
  },

  /**
   * Initialie Veriff flow.
   *
   * @private
   */

  async mounted() {
    if (this.user.idVerificationStatus === VerificationStatus.Verified) {
      this.$emit('decision', true);
    } else {
      try {
        const status = await this.createSession(this.user);
        if (status === MESSAGES.FINISHED) {
          const decision = await this.checkStatus();
          this.$emit('decision', decision === VerificationStatus.Verified);
        } else if (!status || status !== MESSAGES.STARTED || status === MESSAGES.CANCELED) {
          this.$emit('decision', false);
        }
      } catch (e) {
        // decision failed somehow or timeout
        this.loading = false;
        this.$emit('decision', false);
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    /**
     * Initiate verification.
     *
     * @private
     */

    initiateVeriff() {
      this.$refs.veriff.querySelector('input').click();
      this.loading = true;
    },

    /**
     * Check descision status in DB.
     *
     * @private
     */

    async checkStatus() {
      return new Promise((resolve, reject) => {
        this.interval = setInterval(async () => {
          const res = await api.get('/account/idVerification');
          if (res && res.status === 'Verified') {
            // eslint-disable-next-line vue/no-mutating-props
            this.user.isVerified = true;
            // eslint-disable-next-line vue/no-mutating-props
            this.user.idVerificationStatus = 'Verified';
            this.loading = false;
            clearInterval(this.interval);
            resolve(res.status);
          }
        }, 1000);
        setTimeout(() => {
          clearInterval(this.interval);
          this.loading = false;
          reject(new Error('timeout'));
        }, 30000);
      });
    },

    /**
     * Create veriff section and mount UI.
     *
     * @private
     */

    async createSession(user = {}, parentId = 'veriff-root') {
      // eslint-disable-next-line global-require
      const { Veriff } = require('@veriff/js-sdk');
      // eslint-disable-next-line global-require
      const { firstName, lastName, email } = user;
      return new Promise((resolve, reject) => {
        const veriff = Veriff({
          host: process.env.NUXT_ENV_VERIFF_HOST,
          apiKey: process.env.NUXT_ENV_VERIFF_API_KEY,
          parentId,
          onSession: (err, response) => {
            if (err) reject(err);
            else {
              createVeriffFrame({
                url: response.verification.url,
                onEvent: (msg) => {
                  switch (msg) {
                    case MESSAGES.STARTED:
                      break;
                    case MESSAGES.CANCELED:
                      this.loading = false;
                      reject(new Error(msg));
                      break;
                    case MESSAGES.FINISHED:
                      resolve(msg);
                      break;
                    default:
                  }
                },
              });
            }
          },
        });
        veriff.setParams({
          person: {
            givenName: firstName,
            lastName,
          },
          vendorData: email,
        });
        veriff.mount({
          submitBtnText: 'Get verified',
          loadingText: 'Please wait...',
        });
      });
    },
  },
};
